import type { FaireProductEntity } from "../../entity_types/product";

export const p_q5sepnt255: FaireProductEntity = {
  token: "p_q5sepnt255",
  type: "product",
  name: "Flower Patch Little Stickies",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/49b96a117bb12b96b0b62ea6db7dc8c4c75c8c568c9c6294cfbe66ba47556b24.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/da18263219ccecd8dae61cfeee8ea9ec144a25458be9e18f6043f52d773a3a82.jpeg",
    "https://cdn.faire.com/fastly/b23a5f5f8852b075b15c3e1632edf54ad664b61c420f8c53a5a9f8f7531302bd.jpeg",
  ],
  priceDollars: 5,
  description:
    "Because sometimes you need a little adhesive! Sweet watercolor illustrations bring joy to everyday tasks - perfect for your desk, home, bathroom mirrors, foreheads. The best part? They’re made in partnership with 3M, which means you get that classic Post-it® Notes stickiness that actually sticks!",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:05.400Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
